// --- Triggering Condition Enum ---
export enum PriceAlertConfigTriggeringPriceEnum {
  MANUAL_PRICE = 'manual_price',
  AVERAGE_PRICE = 'average_price',
}

export const PriceAlertConfigTriggeringPriceOptions = [
  { label: 'averagePrice', value: PriceAlertConfigTriggeringPriceEnum.AVERAGE_PRICE },
  { label: 'manualPrice', value: PriceAlertConfigTriggeringPriceEnum.MANUAL_PRICE },
];

export const getPriceAlertConfigTriggeringPrice = (type: string): string => {
  const option = PriceAlertConfigTriggeringPriceOptions.find((option) => option.value === type);
  return option ? option.label : type;
};


export const getMetricDisplayNameWithTranslation = (
  metric: string,
  t: (key: string) => string
): string => {
  const option = PriceAlertConfigTriggeringPriceOptions.find((opt) => opt.value === metric);
  return option ? t(option.label) : metric;
};


export const getTranslatedMetricOptions = (t: (key: string) => string) => {
    return PriceAlertConfigTriggeringPriceOptions.map((option) => {
      const translatedLabel = t(option.label);
      return {
        ...option,
        label: translatedLabel,
      };
    });
  };